import { makeStyles } from 'tss-react/mui';

const fontFamily = '"Lexend", "Helvetica", "Arial", sans-serif;';

export const useStyles = makeStyles()((_, { greyed, smaller }) => ({
  container: {
    display: 'inline-flex',
    alignItems: 'center',
    border: 'solid thin var(--light-gray)',
    borderRadius: '4px',
    backgroundColor: greyed ? 'var(--light-gray)' : 'white',
    padding: `${smaller ? '1' : '4'}px 8px`,
    fontFamily,
    lineHeight: '16px',
    fontWeight: 500,
    color: 'var(--primary-color)',
    boxSizing: 'border-box',
    maxWidth: '100%'
  },
  allowHover: {
    '&:hover': {
      backgroundColor: '#eeeeee'
    }
  },
  textContainer: {
    fontSize: '12px',
    width: '100%',
    display: 'block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  closeIcon: {
    width: 10,
    minWidth: 10,
    height: 10,
    marginLeft: 5,
    cursor: 'pointer',
    '& path': {
      fill: 'var(--primary-color)'
    },
    '&:hover': {
      '&:path': {
        fill: 'red'
      }
    }
  },
  cursorPointer: {
    cursor: 'pointer'
  }
}));
